import { render, staticRenderFns } from "./SaCategory.vue?vue&type=template&id=12a60ffa&"
import script from "./SaCategory.vue?vue&type=script&lang=js&"
export * from "./SaCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports